import { TermsPage } from "@/pages/TermsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_unauthenticated/terms")({
  component: TermsPage,
});
